// export function navigationMobile() {
//
// // Toggle menu click
// $(function() {
//     // Öffnen
//     $(".toggle-menu").click(function() {
//         $(this).toggleClass("active");
//         $('.mainMenuMobile').toggleClass("open");
//
//         if ($('body').css('overflow') === 'hidden') {
//             $('body').css('overflow', '');
//         } else {
//             $('body').css('overflow', 'hidden');
//         }
//     });
// });
// // // Navigation Mobile
//
// $(function() {
//     const navToggle = document.querySelector('.menu-toggle');
//     const header = document.querySelector('.vs-main-navigation');
//     const subMenuToggles = document.querySelectorAll('.mainMenuMobile .has-children > a');
//     const subMenuBackToggles = document.querySelectorAll('.subMenuBack');
//
//
//     navToggle && navToggle.addEventListener('click', function() {
//         header.classList.toggle('menu-is-open');
//
//     });
//
//     subMenuToggles && subMenuToggles.forEach(function(toggle) {
//         toggle && toggle.addEventListener('click', function(event) {
//             event.preventDefault();
//             toggle.parentElement.classList.add('is-open');
//             header.querySelector('.mainMenuMobile').classList.add('submenu-is-open');
//         });
//     });
//
//     subMenuBackToggles && subMenuBackToggles.forEach(function(toggle) {
//         toggle && toggle.addEventListener('click', function(event) {
//             event.preventDefault();
//             header.querySelector('.is-open').classList.remove('is-open');
//             header.querySelector('.mainMenuMobile').classList.remove('submenu-is-open');
//
//         });
//     });
// })();
// }


export function navigationMobile() {

// Toggle Mobile Menu
    $(function() {
        $(".toggle-menu").click(function() {
            $(this).toggleClass("active");
            $('.mainMenuMobile').toggleClass("open");

            if ($('body').css('overflow') === 'hidden') {
                $('body').css('overflow', '');
            } else {
                $('body').css('overflow', 'hidden');
            }
        });
    });

    $(function() {
    const navToggle = document.querySelector('.menu-toggle');
    const header = document.querySelector('.vs-main-navigation');
        navToggle && navToggle.addEventListener('click', function() {
            header.classList.toggle('menu-is-open');
        });
    });


    $(function() {
        $('.open-sub-menu').click(function(e) {
            e.preventDefault();
            var parentLi = $(this).closest('li.has-children');
            parentLi.find('> .vs-main-menu-mobile-sub-menu').first().css({'transform': 'translateX(0%)', 'opacity': '1', 'visibility': 'visible'});
        });

        $('.vs-main-menu-mobile-sub-menu__menu-back').click(function(e) {
            e.preventDefault();
            $(this).closest('.vs-main-menu-mobile-sub-menu').css({'transform': 'translateX(100%)', 'opacity': '0', 'visibility': 'hidden'});
        });
    });

}